import React from "react";
import { LineChart, AlertCircle } from "lucide-react";
import ChargeCollaborateurCard from "../molecules/ChargeCollaborateurCard";

function ChargeParCollaborateurSection({ charge, aAffecter }) {
  return (
    <div className="mb-4">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-3">
        <div className="flex items-center gap-2 font-bold text-sm text-gray-900">
          <span className="inline-flex text-[#6e1a36]">
            <LineChart size={16} />
          </span>
          Charge par collaborateur
          <span className="font-normal text-xs text-gray-400">
            dossiers affectés par intervenant
          </span>
        </div>
        <div className="flex items-center gap-3.5 text-xs text-gray-400">
          <span className="inline-flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-sm bg-red-600"></span>En retard
          </span>
          <span className="inline-flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-sm bg-amber-600"></span>En cours
          </span>
          {aAffecter > 0 && (
            <span className="inline-flex items-center gap-1 text-amber-700 font-semibold">
              <AlertCircle size={13} className="text-amber-700" /> {aAffecter} à affecter
            </span>
          )}
        </div>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-1.5 items-start">
        {charge.map((col) => (
          <ChargeCollaborateurCard key={col.user.id} user={col.user} dossiers={col.dossiers} />
        ))}
        {charge.length === 0 && (
          <div className="p-5 text-center text-gray-400 text-sm">
            Aucun dossier ouvert affecté pour le moment.
          </div>
        )}
      </div>
    </div>
  );
}

export default ChargeParCollaborateurSection;
